import EventAvailable from '@mui/icons-material/EventAvailable';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function EventAvailableIcon(props: FixMe) {
  return <EventAvailable {...props} />;
}

export default EventAvailableIcon;
